import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/progress-ring/progress-ring.js';

import { css, unsafeCSS } from 'lit';
import {unsafeCSSIcon} from "../../../styles/icons";
import {SpUiConfigService} from '../../../services/sp-ui-config.service';

export const styles =
    css`
        .header-buttons {
            position: absolute;
            top: 15px;
            right: 15px;
            height: 32px;
            background-color: #ececec;
            border-top-left-radius: 16px;
            border-bottom-left-radius: 16px;
            z-index: 99;
            margin: 0;
            padding: 0;
            list-style-type: none;
        }

        .header-buttons li {
            display: block;
            float: left;
            margin-left: 5px;
        }

        .header-buttons li.close {
            margin-left: 14px;
            margin-right: 14px;
        }

        .header-buttons li a {
            display: block;
            width: 32px;
            height: 32px;
            box-sizing: border-box;
            background-position: center center;
            background-color: rgb(var(--sp-color-a));
            background-repeat: no-repeat;
        }

        .header-buttons li.circle a {
            border-radius: 16px;
            border: 2px solid #FFFFFF;
            background-color: rgb(var(--sp-color-a));
            box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.05);
            cursor: pointer;
        }

        .header-buttons li.circle a.selected {
            background-color: #808080;
            cursor: default;
        }

        .header-buttons li.circle.user-ranking a {
            background-image: url(${unsafeCSSIcon('user', {size: 'x128', color: 'white'})});
            background-size: 24px auto;
            background-position: bottom center;
        }

        .header-buttons li.circle.spot-ranking a {
            background-image: url(${unsafeCSSIcon('spotteron', {size: 'x128', color: 'white'})});
            background-size: 20px auto;
        }

        .header-buttons li.circle.field-ranking a {
            background-image: url(${unsafeCSSIcon('bar-chart', {size: 'x128', color: 'white'})});
            background-size: 16px auto;
        }

        .header-buttons li.circle.field-flow a {
            background-image: url(${unsafeCSSIcon('line-chart', {size: 'x128', color: 'white'})});
            background-size: 20px auto;
        }

        .header-buttons li.close a {
            background-image: url(${unsafeCSSIcon('close', {size: 'x128', color: 'grey-dark'})});
            background-size: 12px auto;
        }

        swiper-container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 80px;
        }

        swiper-slide {
            position: relative;
        }

        .slide-title {
            display: flex;
            align-items: center;
            position: absolute;
            top: 15px;
            left: 15px;
            height: 32px;
            font-size: 16px;
            padding-left: 26px;
            background-size: 16px auto;
            background-position: left center;
            background-repeat: no-repeat;
            text-transform: uppercase;
        }

        .user-ranking-slide .slide-title {
            background-image: url(${unsafeCSSIcon('user', {size: 'x128', color: 'grey-dark'})});
        }

        .spot-ranking-slide .slide-title {
            background-image: url(${unsafeCSSIcon('spotteron', {size: 'x128', color: 'grey-dark'})});
        }

        .field-ranking-slide .slide-title {
            background-image: url(${unsafeCSSIcon('bar-chart', {size: 'x128', color: 'grey-dark'})});
        }

        .field-flow-slide .slide-title {
            background-image: url(${unsafeCSSIcon('line-chart', {size: 'x128', color: 'grey-dark'})});
            background-size: 20px auto;
        }

        .slide-content {
            position: absolute;
            top: 60px;
            bottom: 0;
            width: 100%;
            overflow-y: scroll;
            overflow: -moz-scrollbars-none;
        }

        .slide-content::-webkit-scrollbar {
            display: none;
        }

        .fade-out-top {
            position: absolute;
            top: 45px;
            left: 0;
            height: 30px;
            width: 100%;
            background-size: auto 30px;
            background-image: url(${unsafeCSS(`${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/background/fade-out-top.png`)});
            background-repeat: repeat-x;
            z-index: 90;
        }

        .fade-out-bottom {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 30px;
            width: 100%;
            background-size: auto 30px;
            background-image: url(${unsafeCSS(`${SpUiConfigService.get('SP_STATIC_ASSET_HOST')}/img/background/fade-out-bottom.png`)});
            background-repeat: repeat-x;
            z-index: 90;
        }

        #field-select {
            position: absolute;
            left: 15px;
            right: 15px;
            bottom: 80px;
        }
    `;
